/**
 * Product Context Plugin for Admin Contextual Panel
 *
 * Handles product pages: /products/:slug
 */

import React from "react";
import { registerContext } from "../contextRegistry";
import MergeButton from "../MergeButton";

function ProductContextPanel({ contextProps }) {
  const { slug } = contextProps;
  return (
    <div>
      <p className="small text-muted mb-2">Viewing product: {slug}</p>
      <div className="d-grid gap-2">
        <MergeButton />
      </div>
    </div>
  );
}

// Register this context
registerContext({
  name: "product",
  priority: 10,
  patterns: [
    {
      pattern: /\/products\/([^/?]+)/,
      extract: (match) => ({ slug: match[1] }),
    },
  ],
  component: ProductContextPanel,
});

export default ProductContextPanel;
